module.exports = __webpack_public_path__ + "img/default-user-icon.0f8e789e.jpg";